import Modifier from 'ember-modifier';

/**
 * Note: this pattern has issue with `if` conditions directly parenting the
 * delegate element, as it will attempt to remove the replaced element.
 */
export default class ElementModifier extends Modifier {
  initialized = false;
  _comment = document.createComment('');
  _element;
  _originalElement;

  modify(element, [ replacementElement ]) {
    if (!this.initialized) {
      this.initialized = true;
      this._element = this._originalElement = element;
    }
    replacementElement ||= this._comment;
    this._element.replaceWith(replacementElement);
    this._element = replacementElement;
  }

  willRemove() {
    this._element.replaceWith(this._originalElement);
  }
}
